import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ExpectedActivitySurvey } from '@shared/models/data-model';
import { RegistrationService } from '@shared/services/registration.service';

export const expectedActivitySurveyResolver: ResolveFn<ExpectedActivitySurvey> = (route, state) => {
    return inject(RegistrationService).getExpectedActivitySurvey();
};
